<template>
  <div>
    <!-- 抖音列表 -->
    <div class="topBox">
      <div class="leftBox">为你找到了<strong>{{pager.total}}</strong>位合适的达人</div>
      <div class="table-head-slot">
        <el-button round size="mini" @click="showCustomDialog">
          <i class="el-icon-setting" style="margin-right: 6px;"></i>自定义列
        </el-button>
        <el-button size="mini" round  v-if="isShowCalendar == 1" @click="batchLockHandle"><i class="el-icon-lock" style="margin-right: 6px;"></i>批量锁档</el-button>
        <el-button size="mini" round  @click="onDrCartBatchJoin"><i class="el-icon-shopping-cart-2" style="margin-right: 6px;"></i>批量添加至清单</el-button>
        <el-button size="mini" round @click="showExportDialg"><i class="el-icon-upload2" style="margin-right: 6px;"></i>导出</el-button>
      </div>
    </div>

    <div class="kol_table">
      <div class="my-vxe-table-wrap" v-if="myColumns.length">
        <!-- 该表格主要用于实现表头吸顶效果，需要保持与下方实际表格的列宽等一致 -->
        <vxe-table
          v-fixed-table-header
          ref="mainTableRef"
          border="inner"
          class="main-table"
          :row-config="{isHover: true}"
          @cell-dblclick="tableBtnClick"
          align="center"
          :loading = "loading"
          :data="vxeTableData"
          @sort-change="sortChange"
          :sort-config="{ remote:true }"
          :row-class-name="rowClassName"
          >
          <vxe-column type="checkbox" width="40" fixed="left"></vxe-column>
          <vxe-column fixed="left" width="340" title="达人信息">
            <template #default="{row}">
              <div class="profile-wrap">
                <div class="img-wrap">
                  <img class="avatar" :src="row.avatar_uri" v-if="row.avatar_uri" alt="">
                  <img class="avatar" src="./../../../assets/images/avatar.jpg" v-else alt="">
                  <img class="sex" v-if="row.sex" :src="require(`@/assets/${row.sex === '男' ? 'man' : 'woman'}.png`)" alt="" style="width: 20px;height: 20px;" />
                </div>
                <div class="info-wrap">
                  <div class="nickname">
                    <img v-if="row?.month_examples_data?.is_hot == '是'" :src="require(`@/assets/images/火爆.png`)" style="margin-right: 4px;">
                    <img v-if="row?.month_examples_data?.is_must == '是'" :src="require(`@/assets/images/必选.png`)" style="margin-right: 4px;">
                    <el-popover trigger="hover">
                      <div class="popover-form">
                        <div class="item">
                          <div class="label">星图ID</div>
                          <div class="value">{{ row.starid }}</div>
                        </div>
                        <div class="item">
                          <div class="label">账号ID</div>
                          <div class="value">{{ row.uniqueId }}</div>
                        </div>
                        <div v-if="row?.month_examples_data?.reason" class="item">
                          <div class="label">推荐理由</div>
                          <div class="value">{{ row?.month_examples_data?.reason }}</div>
                        </div>
                        <div v-if="row?.is_ban == 1 || row?.is_black == 1 || row?.is_sup_black == 1"  class="item">
                          <div class="label">达人情况说明</div>
                          <div class="value">
                            <span v-if="row?.is_ban == 1">不推荐</span>
                            <span v-else-if="row?.is_black == 1 ">达人已被拉黑</span>
                            <span v-else-if="row?.is_sup_black == 1">归属供应商被拉黑</span>
                          </div>
                        </div>
                        <div v-if="row?.is_ban == 1 || row?.is_black == 1 || row?.is_sup_black == 1" class="item">
                          <div class="label">不推荐理由</div>
                          <div  class="value">
                            <template v-if="row?.is_ban == 1 ">
                              {{ row?.ban_data?.reason }}
                            </template>
                            <template v-if="row?.is_black == 1 || row?.is_sup_black == 1 ">
                              {{ row?.black_data?.black_reasons }}
                            </template>
                          </div>
                        </div>
                      </div>
                      <div slot="reference" class="sp-nickname" :class="{'gray-nickname': row?.is_ban == 1 || row?.is_black == 1 || row?.is_sup_black == 1|| row?.ban_data?.reason}" :title="row.nickname">{{ row.nickname }}</div>
                    </el-popover>
                    <el-tooltip v-if="row.warnTips" placement="top">
                      <div slot="content">
                        {{ row.warnTips }}
                      </div>
                      <i class="el-icon-warning-outline warnTips" ></i>
                    </el-tooltip>
                    <img src="@/assets/images/schedule/i-calendar.png" class="i-calendar" v-if="['自孵化号','签约号'].includes(row.logings)" @click="showCalendarDia(row)">
                    <img v-if="row.is_competitive == 1" src="@/assets/images/schedule/排竞.png" class="pj_icon"  @click="showPjModal(row)">
                  </div>
                  <div class="tag-wrap">
                    <SupplierPopover v-if="row.logings" :disabled="!is_product || (!row.logings.includes('合作号') && !row.logings.includes('野生'))" :row="row">
                    </SupplierPopover>
                    <i v-if="row?.month_examples_data?.discount" style="background-color:#e6f8ea;color:#00b42a;">{{row?.month_examples_data?.discount}}折</i>
                    <!-- <i class="special" v-if="row.mcn && (row.mcn === '畅玩文化' || row.mcn.includes('畅玩达人'))" >畅玩达人</i> -->
                  </div>
                  <div class="icon-wrap">
                    <img v-if="row.logings === '签约号' && row.contract_type=='独家'" src="@/assets/images/djdr.png" >
                    <img v-else-if="row.logings === '签约号' && ['非独家，不分商机先后','非独家，优先商机'].includes(row.contract_type)" src="@/assets/images/fdjdr.png" >
                    <img v-else-if="row.logings === '签约号' && row.contract_type=='弱绑定签约达人'" src="@/assets/images/rbddr.png" >
                    <img v-if="row.is_month_examples=='1'" src="@/assets/images/bykl.png" >
                    <el-popover
                      class="pop-special_saletype"
                      v-if="row.special_saletype"
                      placement="top-start"
                      title=""
                      width="200"
                      trigger="hover">
                      <div v-html="row.special_saledesc || '暂无描述'"></div>
                      <img slot="reference" :src="require(`@/assets/images/${row.special_saletype}.png`)"  >
                    </el-popover>
                    <el-tooltip v-if="row.bl_status == '是'" effect="dark" content="该达人支持保量或历史合作项目中有保量案例，具体条款详见合作明细。" placement="top">
                      <img :src="require(`@/assets/images/支持保量.png`)"  >
                    </el-tooltip>
                    <img v-if="row.is_cooling == 1" :src="require(`@/assets/images/冷却.png`)"  >
                    <img v-if="row.isHistorySign" :src="require(`@/assets/images/历史签约号.png`)"  >
                    <el-tooltip v-if="row.isNewSign" effect="dark" content="1、首次入库，成为签约号的前三个自然月。2、非首次入库，从别的账号状态(例如野生)首次改成签约号的前三个自然月。3、非首次入库，从签约号状态改成别的状态(例如野生)再改回签约号的前三个自然月。" placement="top">
      <img :src="require(`@/assets/images/新签约.png`)"  >
    </el-tooltip>
                  </div>
                  <RelatedTalents :row="row"></RelatedTalents>
                  <div class="mechanism">
                    <span :title="row.location">{{ row.location }} | </span>
                    <span style="cursor: pointer;" @mouseenter="showStarChangeHistory($event,row)" @mouseleave="hideStarChangeHistory">机构：{{ row.star || '-' }}</span>
                  </div>
                  <div class="default-order">
                    <!-- <span>内容：<i>{{ row.avg_quality }}</i></span>
                    <span>合作：<i>{{ row.avg_experience }}</i></span>
                    <span>数据：<i>{{ row.avg_effect }}</i></span> -->
                    <!-- 0724 违约商单暂不展示 -->
                    <!-- <span class="txt" v-if="row.error_bussiness_order_num">违约商单：{{ row.error_bussiness_order_num }}</span> -->

                  </div>
                </div>
              </div>
            </template>
          </vxe-column>
          <!-- 内容找人时才有的列 -->
          <vxe-column v-if="commonQuery.searchType == '内容找人'" title="相关视频" field="video_count" width="100" :sortable="true">
            <template #default="{row}">
                <span style="color:#ff6f28; cursor: pointer;">
                  {{row.video_count}}
                  <img :src="require('@/assets/images/相关视频播放.png')" style="vertical-align:text-bottom;width:20px;">
                </span>
            </template>
          </vxe-column>
          <vxe-column
          v-for="(item, index) in myColumns"
          :key="item.field + index"
          :field="item.field"
          :fixed="item.fixed || ''"
          :title="item.title"
          :class-name="item.field.endsWith('_mychart') ? 'chart-wrap' : ''"
          :sortable="item.sortable"
          :titlePrefix="item.titlePrefix"
          :min-width="item.width || 140"
          >
            <template #header v-if="item.titleStr">
              <span v-html="item.titleStr"></span>
            </template>
            <template #default="{column, row}">
              <div v-if="item.formatter && typeof item.formatter == 'function'">{{ item.formatter({cellValue:row[column.field],row,column}) }}</div>
              <div class="bar-cell-wrap" style="width: 100%" v-else-if="column.field.endsWith('_mychart')">
                <el-popover
                  v-if="row[column.field] && row[column.field].hasData"
                  placement="top"
                  title=""
                  width="300"
                  trigger="click">
                    <bar :info="row[column.field]" style="height: 160px; width: 300px"></bar>
                  <p slot="reference" class="p-no-data">{{ row[column.field].firstData || "" }}</p>
                </el-popover>
                <p v-else-if="row[column.field]?.length == 0" class="p-no-data">0</p>
                <p v-else class="p-no-data">暂无数据</p>
              </div>
              <div class="bar-cell-wrap" style="width: 100%" v-else-if="column.field.includes('devidedrate')">
                <!-- v-if="row[column.field]&& row[column.field].hasData" -->
                <el-popover
                  v-if="row[column.field]"
                  placement="top"
                  title=""
                  width="300"
                  trigger="click">
                  <bar :info="row?.devidedrateChart" style="height: 160px; width: 300px"></bar>
                  <!-- <p slot="reference" class="p-no-data" @click="getDevidedrateChart('70675')">{{ row[column.field] ||"" }}</p> -->
                  <p slot="reference" class="p-no-data" @click="getDevidedrateChart(row.id)">{{ row[column.field] ||"" }}</p>
                </el-popover>
                <p v-else-if="row[column.field]?.length == 0" class="p-no-data">0</p>
                <!-- <p v-else class="p-no-data">暂无数据</p> -->
                <p v-else class="p-no-data">{{row[column.field]}}</p>
              </div>
              <div class="price_text" v-else-if="column.field.endsWith('_c_count')">
                <el-popover placement="bottom" trigger="click">
                  <div class="table-wrap">
                    <el-table v-if="detailTableData" v-loading="detailTableLoading" height="300" :data="detailTableData" size='small' :header-cell-style="{ background: '#f5f7fa' }">
                      <el-table-column v-for="(item, idx) in detail_field" :key="idx" :fixed="item.fields === 'product' ? 'left' : false"
                        width="150" :sortable="item.ispx ? 'custom' : false" :prop="item.fields" :label="item.name" ></el-table-column>
                      <template #empty>
                        <div class="no-data-wrap">
                          <span>暂无数据</span>
                        </div>
                      </template>
                    </el-table>
                    <el-pagination
                      style="margin-top: 10px;text-align: center;"
                      small
                      background
                      layout="prev, pager, next"
                      :page-size="detailTableLimit"
                      :total="detailTableTotal"
                      :current-page.sync="detailTablePage"
                      @current-change="handleClick(row, column.field)">
                    </el-pagination>
                  </div>
                  <div slot="reference">
                    <div style="color:#606266;font-size: 14px;font-weight: 400;cursor: pointer;" @click="()=>{detailTablePage=1;handleClick(row, column.field)}">
                      {{handleNum(row[column.field], column)}}
                    </div>
                  </div>
                </el-popover>
              </div>
              <div class="price_text" v-else-if="['twentyprice', 'sixtyprice', 'sixtyoverprice', 'price_61', 'price_73', 'price_90', 'price_91', 'price_9', 'price_56', 'price_52', 'price_53' ].includes(column.field)">
                <el-tooltip v-if="row?.month_examples_data?.is_same_price == '否'" effect="dark" placement="top-start">
                  <template #content>
                    <span>该达人实际接单价格与平台不一致，其他备注说明：{{row?.month_examples_data?.notes}}</span>
                  </template>
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
                <el-popover placement="bottom" trigger="hover">
                  <div>
                    <div style="display: flex;justify-content: space-between;">
                      <!-- <span>1-20s报价</span><span style="color:#FF5C00;">{{row?.twentyprice ?  handleNum(row?.twentyprice, column) : '-'}}</span> -->
                      <span>1-20s报价</span><span style="color:#FF5C00;">{{row?.twentyprice ?  "￥" + (Number(row?.twentyprice.toLocaleString()).toLocaleString()) : '-'}}</span>
                    </div>
                    <div style="display: flex;justify-content: space-between;">
                      <!-- <span>21-60s报价</span><span style="color:#FF5C00;">{{row?.sixtyprice ?  handleNum(row?.sixtyprice, column) :'-'}}</span> -->
                      <span>21-60s报价</span><span style="color:#FF5C00;">{{row?.sixtyprice ? "￥"+(Number(row?.sixtyprice.toLocaleString()).toLocaleString()) : '-'}}</span>
                    </div>
                    <div style="display: flex;justify-content: space-between;">
                      <!-- <span>60s以上报价</span><span style="color:#FF5C00;">{{row?.sixtyoverprice ?  handleNum(row?.sixtyoverprice, column) :'-'}}</span> -->
                      <span>60s以上报价</span><span style="color:#FF5C00;">{{row?.sixtyoverprice ? "￥"+(Number(row?.sixtyoverprice.toLocaleString()).toLocaleString()) : '-'}}</span>
                    </div>
                  </div>
                  <span slot="reference" v-if="row.online_status != 2">
                      <!-- {{row[column.field]? handleNum(row[column.field], column) :'-'}}<i class="el-icon-arrow-down"></i> -->
                    {{row[column.field] ? "￥"+(Number(row[column.field]).toLocaleString()) : '暂无报价'}}<i class="el-icon-arrow-down"></i>
                  </span>
                  <span slot="reference" v-else>
                      <!-- {{row[column.field]? handleNum(row[column.field], column) :'-'}}<i class="el-icon-arrow-down"></i> -->
                    {{'休息'}}<i class="el-icon-arrow-down"></i>
                  </span>
                </el-popover>
              </div>
              <div v-else-if="column.field == 'accounttype'">
                <el-popover
                  v-if="row.accounttype && row.accounttype.split"
                  trigger="hover"
                >
                  <span v-if="row.contenttype" class="popover-tag-wrap">
                    <template v-if="row.contenttype && row.contenttype.split">
                      <i v-for="(tag, tagIdx) in row.contenttype.split(',')" :key="tagIdx">{{ tag }}</i>
                    </template>
                  </span>
                  <span slot="reference">
                      <i class="tag" v-for="(tag, tagIdx) in row.accounttype.split(',')" :key="tagIdx">{{ tag }}</i>
                  </span>
                </el-popover>
              </div>
              <div v-else-if="column.field == 'segment_labels'">
                <i class="tag" v-for="(tag, tagIdx) in row?.segment_labels?.split(',')" :key="tagIdx">{{ tag }}</i>
              </div>
              <div v-else-if="column.field == 'industry_tags'">
                <i class="tag" v-for="(tag, tagIdx) in row.industry_tags?.split(',')" :key="tagIdx">{{ tag }}</i>
              </div>
              <div v-else-if="column.field == 'video_count'">
                <span style="color:#FF5C00;cursor: pointer;">{{ row[column.field] }}</span>
              </div>
              <div v-else-if="column.field == 'xglt_count'">
                <el-popover ref="popover" :visible="true" width="400" trigger="hover"
                    :open-delay="500" :popper-options="{ removeOnDestroy: true }"
                    @show="onXgltCountPopShow(row)">
                    <div class="xglt-count-popover">
                      <div class="form">
                        <div class="form-item" v-for="(item, index) in row._xgltCountData" :key="index">
                          <div class="title">{{ item.title }}</div>
                          <div class="value">{{ item.value || '-' }}</div>
                        </div>
                      </div>
                      <div class="to-panel" @click="onToPage(row)">
                        <img src="@/assets/images/xglt-computer.png" >
                        在星广达人看板中查看更多信息
                      </div>
                    </div>
                    <i style="color:#FF5C00;cursor: pointer;" slot="reference" >{{ row.xglt_count || 0 }}</i>
                </el-popover>
              </div>
              <div v-else-if="column.field == 'xglt_option'">
                  <i class="tag" v-for="(tag, tagIdx) in row.xglt_option?.split(',')" :key="tagIdx">{{ tag }}</i>
              </div>
              <span v-else>{{ handleNum(row[column.field], column) }}</span>
            </template>
          </vxe-column>
          <vxe-column title="操作" fixed="right" width="190">
            <template #default="scope">
              <div style="display: flex;justify-content: center;flex-wrap: wrap;">
                <el-dropdown @command="(command)=>handleAddCommand(scope,command)">
                  <span style="width: 30px;">
                    <el-tooltip placement="top" content="添加达人">
                      <img class="rowBtn"  src="@/assets/plus.png" alt="">
                    </el-tooltip>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="add-to-xd">添加至询单</el-dropdown-item>
                    <el-dropdown-item command="add-to-cart">添加至达人清单</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-tooltip placement="top" content="查看抖音主页">
                  <img class="rowBtn" @click="onToDrHome(scope)" src="@/assets/home.png" alt="去主页">
                </el-tooltip>
                <el-tooltip placement="top" content="查看代表视频">
                  <img class="rowBtn" @click="onRepresentVideoShow(scope)" src="@/assets/fire.png" alt="">
                </el-tooltip>
                <!-- <img class="rowBtn" @click="showCalculator(scope)" src="@/assets/calc.png" alt=""> -->
                <el-tooltip placement="top" content="查看达人详情">
                  <img class="rowBtn" @click="tableBtnClick(scope)" src="@/assets/file.png" alt="">
                </el-tooltip>
                <el-dropdown @visible-change="handleDrop($event, scope.row)">
                  <span style="cursor: pointer">
                    <img class="rowBtn" src="@/assets/more.png" alt="">
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <template v-if="dropRole.isread || dropRole.isedit">
                      <el-dropdown-item v-if="dropRole.isedit" @click.native.capture="toCrmLibrary(scope, 'add')">媒体库编辑</el-dropdown-item>
                      <el-dropdown-item v-if="dropRole.isread" @click.native.capture="toCrmLibrary(scope, 'detail')">媒体库详情</el-dropdown-item>
                    </template>
                    <el-dropdown-item v-else-if="dropdownLoading">
                        加载中<i class="el-icon-loading"></i>
                    </el-dropdown-item>
                    <el-dropdown-item v-else>
                        无可操作项
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

              </div>
            </template>
          </vxe-column>
        </vxe-table>

        <vxe-pager
          background
          :align="'right'"
          class="my-list-pager"
          @page-change="pageChange"
          :current-page.sync="pager.page"
          :page-size.sync="pager.limit"
          :page-sizes="[15, 30, 50]"
          :total="pager.total"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']">
        </vxe-pager>
      </div>


      <el-dialog title="自定义列" :visible.sync="customDialog.show" class="custom-col-dialog-wrap">

        <h3>请筛选您要展示的达人指标</h3>
        <div style="color:#4080FF"><i class="el-icon-warning" style="margin-right: 6px;"></i>选中的指标将被展示于达人列表中</div>
        <h5 style="font-size: 14px;">可展示的达人指标(通用)</h5>
        <el-checkbox-group v-model="customDialog.form.checkList">
          <el-checkbox
            v-for="(item, index) in baseColumns"
            :key="index"
            :label="item.title"
            :disabled="item.disabled || false"
            style="margin-bottom: 10px"
          >
          </el-checkbox>
        </el-checkbox-group>
        <!-- <h5 style="font-size: 14px;">可展示的达人指标(仅限有过短视频一口价/短视频资源包合作的达人)</h5>
        <el-checkbox-group v-model="customDialog.form.cooperateList">
          <el-checkbox
            v-for="(item, index) in cooperateColumns"
            :key="index"
            :label="item.title"
            :disabled="item.disabled || false"
            style="margin-bottom: 10px"
          >
          </el-checkbox>
        </el-checkbox-group> -->
        <el-divider></el-divider>
        <h5 style="font-size: 14px;">展示报价类型</h5>
        <el-radio-group v-model="customDialog.form.priceType">
          <el-radio v-for="(item, index) in priceTypeList" :key="index" :label="item.label" :disabled="item.disabled">{{item.name}}</el-radio>
          <!-- <el-radio :label="1"> 1-20s报价</el-radio>
          <el-radio :label="2"> 21-60s报价</el-radio>
          <el-radio :label="3"> 60s以上报价</el-radio>
          <el-radio :label="4"> 明星视频</el-radio>
          <el-radio :label="5"> 合集视频</el-radio>
          <el-radio :label="6"> 抖音短视频共创-主投稿达人</el-radio>
          <el-radio :label="7"> 抖音短视频共创-参与达人</el-radio> -->
        </el-radio-group>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="customDialog.show = false">取 消</el-button>
          <el-button size="small" type="primary" @click="customDialogConfirm">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 自孵化档期 -->
      <Calendar :outerDiaVisible.sync="outerDiaVisible" :info="calendarInfo"></Calendar>

      <!-- 批量锁档 -->
      <ScheduleBatchAddModal ref="ScheduleBatchAddModal"></ScheduleBatchAddModal>

      <DrJoinXdModal :drInfo="currentDrInfo" :show.sync="drJoinShow" />

    </div>
    <exportDialg :exportDialg = "exportDialg" @exportDialgConfirmFn ="exportDialgConfirmFn"></exportDialg>

    <calcDialog :show.sync="calcDialogData.show" :talentInfo="calcDialogData.talentInfo"></calcDialog>

    <RepresentVideoModal  ref="representVideo" :talentInfo="representVideoTalentInfo" />
    <RelatedVideoModal  ref="relatedVideo" :otherQuery="{descsearch:commonQuery.descsearch || '',desctimesearch:commonQuery.desctimesearch || ''}" :talentInfo="relatedVideoTalentInfo" />

    <div ref="custom_popver" class="custom-popver">
      <vxe-table :data="starChangeHistory">
        <vxe-column field="optdt" title="更新时间" ></vxe-column>
        <vxe-column field="oldval" title="更新前机构" ></vxe-column>
        <vxe-column field="newval" title="更新后机构" ></vxe-column>
      </vxe-table>
    </div>
    <PjModal ref="pjModal" :show.sync="pjModalShow" :id="pjId"></PjModal>
  </div>
</template>

<script>
import * as XLSX from 'xlsx'
export default {
  name: 'dyTable',
  props: ["commonQuery", "isShowCalendar"],
  components: {
    Bar: () => import('@/components/newEchart/Bar.vue'),
    Calendar: () => import("@/components/calendar/calendar.vue"),
    DrJoinXdModal:() => import("../components/DrJoinXdModal.vue"),
    exportDialg:() => import("../components/exportDialg.vue"),
    calcDialog: () => import("../components/calcDialog.vue"),
    RepresentVideoModal: () => import("../components/RepresentVideoModal.vue"),
    RelatedVideoModal: () => import("../components/RelatedVideoModal.vue"),
    ScheduleBatchAddModal: () => import("@/pages/kol-list/components/ScheduleBatchAddModal.vue"),
    SupplierPopover: () => import("@/pages/kol-list/components/SupplierPopover.vue"),
    PjModal: () => import("@/pages/kol-list/components/PjModal.vue"),
    RelatedTalents: () => import("@/pages/kol-list/components/RelatedTalents.vue"),

  },
  data() {
    return {
      detailTableLoading: false,
      detailTableData: [],
      detailTableTotal: 0,
      detailTablePage: 1,
      detailTableLimit: 15,
      detail_field:[],
      priceTypeList:[
        {label:1, name:'1-20s报价',value:'_20',disabled:false},
        {label:2, name:'21-60s报价',value:'0',disabled:false},
        {label:3, name:'60s以上报价',value:'_999',disabled:false},
        {label:4, name:'明星视频',value:'_61',disabled:false},
        {label:5, name:'合集视频',value:'_73',disabled:false},
        {label:6, name:'抖音短视频共创-主投稿达人',value:'_90',disabled:false},
        {label:7, name:'抖音短视频共创-参与达人',value:'_91',disabled:false},
        {label:8, name:'品牌推广专场（按小时）',value:'_9',disabled:false},
        {label:9, name:'品牌推广专场（按天）',value:'_56',disabled:false},
        {label:10, name:'电商带货专场',value:'_52',disabled:false},
        {label:11, name:'电商带货拼场',value:'_53',disabled:false},

      ],
      searchOptionsObj: {
        detail_field: [
          {
            fields:"product",
            name:"营销标的",
          },
          {
            fields:"game_type",
            name:"游戏类型",
          },
          {
            fields:"order_num",
            name:"订单单号",
          },
          {
            fields:"ordertype",
            name:"产品类型",
          },
          {
            fields:"ordertype",
            name:"产品名",
          },
          {
            fields:"profit_rate",
            name:"实际利润率",
          },
          {
            fields:"talent_price",
            name:"达人报价",
          },
          {
            fields:"at_total_expenses",
            name:"总支出（税后）",
          },
          {
            fields:"at_expenses",
            name:"实际支付成本税后",
          },
        ],
      },
      exportDialg:{
        show: false,
        checkListInit:[],
        baseColumns:[],
        quotationColumns:[],
        fansColumns: [],
        worksColumns:[],
        audienceColumns:[],
        liveColumns: []
      },
      priceType: 2,
      checkList: [],
      query: {},
      vxeTableData: [],
      sort_type: true,
      leftnum1: 0,
      leftnum2: 0,
      fixedShow: false,
      favoriteList: [],
      subPageList: [],  // 通过详情点击的子页面
      barData: {
        xAxis: [],
        data: [
          {
            color: '#3F90FD',  // 封装时添加的属性，会添加至itemStyle配置中
            name: '',
            type: 'line',
            smooth: true,
            data: [],
            ...{
              areaStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: 'rgba(63, 144, 253, 0.2)' // 0% 处的颜色
                  }, {
                    offset: 1, color: 'rgba(255, 255, 255, 0.01)' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                },
              }
            },  // 传入任何官方支持的配置
          },
        ],
        custom: {
          legend: {show: false},
          yAxis: { show: false },
          xAxis: {
            axisLabel: {
              fontSize: 12,
              rotate: 45,
            }
          },
          grid: {
            left: "5",
            right: "5",
            top: "20%",
            bottom: "5%"
          },
          tooltip: {
            enterable: true,
            appendToBody: true,
            formatter: (params, ticket, cb) => {
              let id = params[0].data.id
              if (this.hoveredChart[id]) {
                if (this.hoveredChart[id].status === 'finished') {
                  return this.handleHoverData(params, this.hoveredChart[id])
                } else {
                  return 'Loading'
                }
              } else {
                this.hoveredChart[id] = {
                  status: 'pending'
                }
                this.getHoverFun(params, ticket, cb)
              }
            }
          },
          series: [
            {
              itemStyle : { normal: {label : {show: true}}}
            }
          ]
        },
      },
      // 已经获取过的悬浮图表数据
      hoveredChart: {},
      baseColumns: [
        { title: '分成税率', field: 'devidedtax', disabled:false, width: 160, sortable: true, fixed: '', },
        { title: '内容分类', field: 'accounttype', disabled:true, width: 160, sortable: false, fixed: '', },
        { title: '畅玩细分标签', field: 'segment_labels', disabled:false, width: 140, sortable: false, fixed: '', titlePrefix: {content: '该达人的畅玩细分标签，若没有你需要的分类，欢迎补充！'}},
        { title: '行业标签', field: 'industry_tags', disabled:false, width: 160, sortable: false, fixed: '', titlePrefix: {content: '根据达人自身商单情况及行业整体情况进行判断达人适合行业'}},
        // 媒体侧自然返点
        { title: '粉丝数', field: 'fans', width: 100, sortable: true, disabled:true, fixed: ''},
        { title: '预期CPM', field: 'cpm', disabled:true, width: 120, sortable: true, fixed: '', titlePrefix: {content: '基于账号预计播放量与当前报价计算的千次播放量费用预估，仅作参考。启用排序时将过滤掉CPM为0或为空的达人，请注意！'}},
        { title: '预期播放量', field: 'expectedplay', disabled:true, width: 130, sortable: true, fixed: '',titlePrefix: {content: '展示达人近30天的预期播放量，更新频率为每周一次'}},
        { title: '男粉占比', field: 'i_percent', disabled:false, width: 130, sortable: true, fixed: '', formatter:({ cellValue})=>{ return (cellValue ?? '-') + '%'} },
        { title: '女粉占比', field: 'o_percent', disabled:false, width: 130, sortable: true, fixed: '', formatter:({ cellValue})=>{ return (cellValue ?? '-') + '%'} },
        { title: '粉丝年龄层', field: 'fansagefb', disabled:false, width: 130, sortable: false, fixed: '', formatter:({ row})=>{ return row.fansagefb +(row.fansagefbpct?`\n(${row.fansagefbpct}%)`:'')}},
        { title: '星图指数', field: 'topscore', width: 110, sortable: true, fixed: ''},
        { title: '完播率', field: 'playcmt', width: 90, sortable: true, fixed: '' },
        { title: '互动率', field: 'interact', width: 90, sortable: true, fixed: '' },
        { title: '近15天粉丝增长量', field: 'fans_increment_within_15d', titleStr: `<span>近15天<br>粉丝增长量</span>`,  width: 130, sortable: true, fixed: '', titlePrefix: {content: '近15日粉丝增长量'}},
        { title: '近15天粉丝增长率', field: 'fans_increment_rate_within_15d', titleStr: `<span>近15天<br>粉丝增长率</span>`, width: 130, sortable: true, fixed: '', titlePrefix: {content: '近15日粉丝增长率'}},
        { title: '自然播放率', field: 'natural_play_pct', width: 130, sortable: true, fixed: '', titlePrefix: {content: '由我司下单发布的最新三个视频（近三个月发布的）的平均值'}},
        { title: '真人出镜', field: 'is_real_person', disabled:false, width: 130, sortable: false, fixed: '', formatter:({ row})=>{ return row?.month_examples_data?.is_real_person || '-'}},
        { title: '最新发布时间', field: 'last_video_time', width: 110, sortable: false, fixed: ''},
        // 直播相关
        { show:()=>this.query.is_live == 1, title: 'ACU', field: 'acu', width: 130, sortable: false, fixed: ''},
        { show:()=>this.query.is_live == 1, title: 'PCU', field: 'pcu', width: 130, sortable: false, fixed: ''},
        { show:()=>this.query.is_live == 1, title: '近期直播场次', field: 'room_cnt', width: 130, sortable: false, fixed: ''},
        { show:()=>this.query.is_live == 1, title: '平均观看人次', field: 'watch_cnt_avg', width: 130, sortable: false, fixed: ''},
        { show:()=>this.query.is_live == 1, title: '平均观看人数', field: 'watch_ucnt_avg', width: 130, sortable: false, fixed: ''},
        { show:()=>this.query.is_live == 1, title: '粉丝观看占比', field: 'fans_watch_rate', width: 130, sortable: false, fixed: ''},
        { show:()=>this.query.is_live == 1, title: '场均涨粉数', field: 'follow_ucnt_avg', width: 130, sortable: false, fixed: ''},
        { show:()=>this.query.is_live == 1, title: '场均点赞比', field: 'like_rate_avg', width:130, sortable: false, fixed: ''},
        { show:()=>this.query.is_live == 1, title: '平均播放时长', field: 'watch_duration_avg', width: 130, sortable: false, fixed: ''},
        { show:()=>this.query.is_live == 1, title: '场均CTR', field: 'ctr_avg', width: 130, sortable: false, fixed: ''},
        { show:()=>this.query.is_live == 1, title: '小风车CTR', field: 'windmill_ctr_avg', width: 130, sortable: false, fixed: ''},
        { show:()=>this.query.is_live == 1, title: '小手柄场均CTR', field: 'handle_ctr_avg', width: 130, sortable: false, fixed: ''},
        { show:()=>this.query.is_live == 1, title: '小手柄场均CVR', field: 'handle_cvr_avg', width: 130, sortable: false, fixed: ''},
        { show:()=>this.query.is_live == 1, title: '小雪花场均CTR', field: 'snowflake_ctr_avg', width: 130, sortable: false, fixed: ''},
        // 直播相关 end
      ],
      // cooperateColumns: [
      //   { title: '合作次数(总)', field: 'c_count', width: 100, sortable: false, fixed: ''},
      //   { title: '合作次数短视频一口价', field: '短视频一口价_c_count', width: 120, sortable: false, fixed: '',},
      //   { title: '合作次数短视频资源包', field: '短视频资源包_c_count', width: 130, sortable: false, fixed: '',},
      //   { title: '利润率短视频一口价', field: '短视频一口价_profit_rate_mychart', width: 110, sortable: false, fixed: ''},
      //   { title: '利润率短视频资源包', field: '短视频资源包_profit_rate_mychart', width: 110, sortable: false, fixed: ''},
      //   { title: '返点比例短视频一口价', field: '短视频一口价_mt_profit_mychart', width: 90, sortable: false, fixed: ''},
      // ],
      pager: {
        page: 1,
        limit: 15,
        total: 0
      },
      sort: 'rank',   // 排序字段
      sortType: 1,  // 0 升序  1：降序
      customDialog: {
        show: false,
        form: {
          checkList: [],
          priceType: 2,
          // cooperateList: [],
        },
        realForm: {
          checkList: [],
          priceType: 2,
          // cooperateList: [],
        }
      },
      ordertypeList: ['短视频一口价', '信息流授权', '短视频-CPA', '效果类商单-CPS', '短视频生态', '直播生态', '短视频-CPM', '短视频CPM旧', '短视频资源包', '直播带货', '电商CPS产品', '一口价直播', '专场直播', '直播一口价','一口价直播（框架资源包）','直播-CPA'],
      outerDiaVisible: false,
      calendarInfo: {},
      tableParams: {},
      checkedData: [],

      hide_fields: [],
      is_product: false, //是否是产品侧人员权限

      exportFrequency: 0,

      currentDrInfo:{},
      drJoinShow:false,

      // initHeight:'48px',
      calcDialogData: {
        talentInfo: {},
        show: false
      },
      loading:false,
      starChangeHistory:[],

      representVideoTalentInfo:null, //查看"代表视频"的达人

      relatedVideoTalentInfo: null, //查看"相关视频"的达人
      pjModalShow: false, // 查看"相关视频"的达人
      pjId:'',
      dropdownLoading: false,
      dropRole: {
        isread: false,
        isedit: false
      }
    };
  },
  computed: {
    myColumns() {
      let columns = this._.cloneDeep(this.baseColumns)
      columns = columns.filter(col => {
        if(('show' in col) && typeof col.show == 'function' ){
          return col.show()
        } else {
          return true
        }
      })
      // columns = [...columns,...this.cooperateColumns]
      // let allcheckList = [...this.customDialog.realForm.cooperateList,...this.customDialog.realForm.checkList]
      let allcheckList = [...this.customDialog.realForm.checkList]
      console.log('allcheckList :>> ', allcheckList);
      columns = columns.filter(x => allcheckList.includes(x.title))
      let selectedOrderType = this.tableParams.order_type || [] // 查询参数选中的产品列表

      let commonList = this._.intersection(selectedOrderType, ['直播生态'])

      // xField和yField用于在获取悬浮数据时取值
      if (commonList.length) {
        commonList.forEach(x => {
          columns.unshift(
            { title: `有效天数(${x})`, field: `${x}_valid_days_mychart`, xField: 'valid_days_time', yField: 'valid_days', width: 150, sortable: false, fixed: '', titlePrefix: {content: '数据范围：近半年合作结算数据；排序规则：合作时间降序'} },
            { title: `有效时长(${x})`, field: `${x}_valid_times_mychart`, xField: 'valid_times_time', yField: 'valid_times', width: 300, sortable: false, fixed: '', titlePrefix: {content: '数据范围：近半年合作结算数据；排序规则：合作时间降序'} }
          )
        })
      }
      commonList = this._.intersection(selectedOrderType, ['短视频生态'])
      if (commonList.length) {
        commonList.forEach(x => {
          columns.unshift(
            { title: `发文数(${x})`, field: `${x}_arc_num_mychart`, xField: 'arc_num_time', yField: 'arc_num', width: 300, sortable: false, fixed: '', titlePrefix: {content: '数据范围：近半年合作结算数据；排序规则：合作时间降序'} },
          )
        })
      }
      commonList = this._.intersection(selectedOrderType, ['短视频生态', '短视频-CPM', '短视频CPM旧'])
      if (commonList.length) {
        commonList.forEach(x => {
          let titleTip = x === '短视频生态' ? '数据范围：近半年合作结算数据；排序规则：合作时间降序' : '数据范围：近半年合作数据，图表日期为视频发布日期；排序规则：合作时间降序'
          columns.unshift(
            { title: `播放量(${x})`, field: `${x}_official_settlement_mychart`, xField: 'official_settlement_time', yField: 'official_settlement', width: 300, sortable: false, fixed: '', titlePrefix: {content: titleTip} }
          )
        })

      }
      commonList = this._.intersection(selectedOrderType, ['直播带货', '电商CPS产品'])
      if (commonList.length) {
        commonList.forEach(x => {
          columns.unshift(
            { title: `GMV(${x})`, field: `${x}_final_gmv_mychart`, xField: 'final_gmv_time', yField: 'final_gmv', width: 300, sortable: false, fixed: '', titlePrefix: {content: '数据范围：近半年合作执行完成数据，图表日期为发布日期；排序规则：合作时间降序'} }
          )
        })

      }
      commonList = this._.intersection(selectedOrderType, ['短视频一口价', '信息流授权'])
      // commonList = this._.intersection(selectedOrderType, ['信息流授权'])
      if (commonList.length) {
        commonList.forEach(x => {
          let content = x == '短视频一口价' ? '依据合作执行完成数据推荐得出，排序时间依据合作时间降序' : '数据范围：近半年合作执行完成数据，图表日期为视频发布日期；排序规则：合作时间降序'
          let xField = x == '短视频一口价' ? 'mt_profit_time' : 'rebate_rate_time'
          let yField = x == '短视频一口价' ? 'mt_profit' : 'rebate_rate'
          columns.unshift(
            { title: `返点比例(${x})`, titleStr: `<span>返点比例<br>${x}</span>`, field: `${x}_${yField}_mychart`, xField: xField, yField: yField, width: 125, sortable: false, fixed: '', titlePrefix: {content} }
          )
        })

      }
      commonList = this._.intersection(selectedOrderType, ['短视频一口价', '信息流授权', '短视频-CPM', '短视频CPM旧', '短视频资源包', '直播带货', '电商CPS产品', '一口价直播', '专场直播', '直播一口价','一口价直播（框架资源包）','直播-CPA'])
      // commonList = this._.intersection(selectedOrderType, ['信息流授权', '短视频-CPM', '短视频CPM旧', '直播带货', '电商CPS产品', '一口价直播', '专场直播', '直播一口价'])
      if (commonList.length) {
        commonList.forEach(x => {
          columns.unshift(
            { title: `利润率(${x})`, titleStr: `<span>利润率<br>${x}</span>`, field: `${x}_profit_rate_mychart`, xField: 'profit_rate_time', yField: 'profit_rate', width: 200, sortable: false, fixed: '', titlePrefix: {content: '数据范围：近半年合作执行完成数据，图表日期为视频发布日期；排序规则：利润率降序'} }
          )
        })

      }

      if (this.customDialog.realForm.priceType == 1) {
        columns.push({ title: '1-20s报价', field: 'twentyprice', width: 200, sortable: true, fixed: 'right'})
      } else if (this.customDialog.realForm.priceType == 2) {
        columns.push({ title: '21-60s报价', field: 'sixtyprice', width: 200, sortable: true, fixed: 'right'})
      } else if (this.customDialog.realForm.priceType == 3) {
        columns.push({ title: '60s以上报价', field: 'sixtyoverprice', width: 200, sortable: true, fixed: 'right'})
      } else if (this.customDialog.realForm.priceType == 4) {
        columns.push({ title: '明星视频', field: 'price_61', width: 200, sortable: true, fixed: 'right'})
      } else if (this.customDialog.realForm.priceType == 5) {
        columns.push({ title: '合集视频', field: 'price_73', width: 200, sortable: true, fixed: 'right'})
      } else if (this.customDialog.realForm.priceType == 6) {
        columns.push({ title: '抖音短视频共创-主投稿达人', field: 'price_90', titleStr: `<span>抖音短视频共创-<br>主投稿达人</span>`, width: 200, sortable: true, fixed: 'right'})
      } else if (this.customDialog.realForm.priceType == 7) {
        columns.push({ title: '抖音短视频共创-参与达人', field: 'price_91',  titleStr: `<span>抖音短视频共创-<br>参与达人</span>`, width: 200, sortable: true, fixed: 'right'})
      } else if (this.customDialog.realForm.priceType == 8) {
        columns.push({ title: '品牌推广专场（按小时）', field: 'price_9',  titleStr: `<span>品牌推广专场（按小时）</span>`, width: 200, sortable: true, fixed: 'right'})
      } else if (this.customDialog.realForm.priceType == 9) {
        columns.push({ title: '品牌推广专场（按天）', field: 'price_56',  titleStr: `<span>品牌推广专场（按天）</span>`, width: 200, sortable: true, fixed: 'right'})
      } else if (this.customDialog.realForm.priceType == 10) {
        columns.push({ title: '电商带货专场', field: 'price_52',  titleStr: `<span>电商带货专场</span>`, width: 200, sortable: true, fixed: 'right'})
      } else if (this.customDialog.realForm.priceType == 11) {
        columns.push({ title: '电商带货拼场', field: 'price_53',  titleStr: `<span>电商带货拼场</span>`, width: 200, sortable: true, fixed: 'right'})
      }

      // todo 这里不需要求产品交集，选了啥就显示啥的产品次数
      // commonList = this._.intersection(selectedOrderType, this.ordertypeList)
      commonList = [...selectedOrderType]
      if (commonList.length) {  // 有给定产品查看权限的才会有此列
        commonList.forEach(x => {
          columns.splice(0, 0, { title: `合作次数${x}`, titleStr: `<span>合作次数<br>${x}</span>`, field: `${x}_c_count`, width: 200, sortable: false, fixed: ''})
        })
        if (commonList.length >= 2) {
          columns.splice(0, 0, { title: `合作次数(总)`, titleStr: `<span>合作次数<br>(总)</span>`, field: `c_count`, width: 125, sortable: false, fixed: ''})
        }
      }
      console.log('this.query :>> ', this.query);
      //星广达人 = '只看星广达人'
      if (this.query.xglt_count == 'xglt_count_min=1') {
        columns.unshift(
          { title: `星广任务数`, field: `xglt_count`, width: 140, sortable: true, fixed: ''},
          { title: `星广账号标签`, field: `xglt_option`, width: 200, sortable: false, fixed: ''},
        )
      }

      if(!this.query.logings?.includes('签约号')){
        //'分成税率' 只有签约号才显示
        const index = columns.findIndex(item => item.field === 'devidedtax')
        if(index != -1){
          columns.splice(index, 1)
        }
      }
      // let longColumns = columns.find(x=>x.field.includes('_c_count') || x.field.includes('_profit_rate_mychart') || x.field.includes('_within_15d'))
      // let Height = ""
      // if(longColumns){
      //   Height = "70px"
      // }else{
      //   Height = "48px"
      // }
      // this.initHeight = Height

      return columns
    },
    // isCanExport() {
    //   // 产品侧&&当日导出未超过10次
    //   return localStorage.getItem('uid') == 1 || (this.is_product && +this.exportFrequency < 10)
    // }
  },
  created() {
    this.hide_fields = JSON.parse(localStorage.getItem("dy_hide_fields") || JSON.stringify([]))

    if(!this.hide_fields.includes("devidedrate")) {
      this.baseColumns.unshift({ title: '媒体侧自然返点', disabled:true,  field: 'devidedrate', width: 180, sortable: true, fixed: '' , titlePrefix: {content: '签约号和自孵化号以运营填写的建议返点比例%为准，合作号/野生优先展示短视频一口价产品的建议返点比例。'}})
    }
    let checkList = JSON.parse(localStorage.getItem("checkList") || JSON.stringify([]))
    if (checkList.length) {
      this.customDialog.form.checkList = [...new Set([...this.baseColumns.filter(item=>item.disabled).map(item=>item.title),...checkList])]
      this.customDialog.realForm.checkList =  [...new Set([...this.baseColumns.filter(item=>item.disabled).map(item=>item.title),...checkList])]
    } else {
      this.customDialog.form.checkList = ["预期播放量","媒体侧自然返点","粉丝数","预期CPM",'内容分类','畅玩细分标签', '行业标签', '男粉占比', '女粉占比', '粉丝年龄层','真人出镜']
      this.customDialog.realForm.checkList = ["预期播放量","媒体侧自然返点","粉丝数","预期CPM",'内容分类','畅玩细分标签', '行业标签', '男粉占比', '女粉占比', '粉丝年龄层','真人出镜']
    }
    console.log('JSON.parse(localStorage.getItem ', JSON.parse(localStorage.getItem("cooperateList")))
    // let cooperateList = JSON.parse(localStorage.getItem("cooperateList") || JSON.stringify([]))
    // if (cooperateList.length) {
    //   this.customDialog.form.cooperateList = cooperateList
    //   this.customDialog.realForm.cooperateList = cooperateList
    // } else {
    //   this.customDialog.form.cooperateList = []
    //   this.customDialog.realForm.cooperateList = []
    // }

    let priceType =  2;
    this.customDialog.form.priceType = priceType
    this.customDialog.realForm.priceType = priceType
    localStorage.setItem("priceType", JSON.stringify(this.customDialog.realForm.priceType));
  },
  watch: {
    commonQuery: {
      deep: true,
      handler(val, oldVal) {
        // if(!Object.keys(oldVal).length){return}
        // console.log('val, 223323232222222222222222222222222222222222 :>> ', this._.cloneDeep(val));
        this.pager.page = 1
        this.query = this._.cloneDeep(val);
        // settimeout是让其他的更改搜索参数的watch监听先执行完毕后再搜索

        if(val.searchType !== oldVal.searchType && val.searchType == '内容找人'){
          this.sort = ''
          this.sortType = 1
        } else if(val.searchType !== oldVal.searchType && val.searchType == '昵称找人' || !this.sort){
          this.sort = 'rank'
          this.sortType = 1
        }
        if(this.query.xglt_count == 'xglt_count_min=1' &&  !this.sort){
          this.sort = 'xglt_count'
          this.sortType = 1
            // this.$nextTick(()=>{
            //   this.$refs.mainTableRef.sort('xglt_count', 'desc')
            // })
        }

        if(val.order_type){
          this.getMyTable()
        }else{
          setTimeout(()=>{
            this.getMyTable()
          },0)
        }
      },
    },
    'commonQuery.product_logings'(val, oldVal){
      if (val == '签约号') {
        // 如果选择签约号，则优先按 独家达人 排序
        this.$refs.mainTableRef.clearSort(this.sort)
        this.sort = 'contract_type'
        this.sortType = 1

      }
    },
    '$store.state.is_product': {
      handler(val){
        this.is_product = val
  },
      immediate: true
    },
    'query.is_live'(n){
      if (n == 1) {
        this.customDialog.realForm.checkList = [...new Set([
          ...this.customDialog.realForm.checkList,
          'ACU','PCU','近期直播场次','平均观看人次','平均观看人数',
          '粉丝观看占比','场均涨粉数','场均点赞比','平均看播放时长',
          '场均CTR','小风车CTR','小手柄场均CTR','小手柄场均CVR','小雪花场均CTR'
        ])]
      }
    }
  },
  methods: {
    rowClassName({row}){
      if(row?.is_black == 1 || row?.is_sup_black == 1){
        return 'gray-color'
      }else if (row?.is_ban == 1 || row?.ban_data?.reason){
        return 'ban-color'
      }
    },
    exportDialgConfirmFn(checkList){
      if(checkList.length == 0){
        this.$message.error('请选择导出列')
        return
      }
      else{
        this.exportHandle(checkList)
      }
    },
    showExportDialg(){

      this.exportDialg.baseColumns = [
        {
            title: "昵称",
            field: "nickname",
            disabled:true,
        },
        {
            title: "账号ID",
            field: "uniqueId",
            disabled:true,
        },
        {
            title: "UID",
            field: "shortid",
            disabled:true,
        },
        {
            title: "星图ID",
            field: "starid",
            disabled:true,
        },
        {
            title: "主页链接",
            field: "homepage"
        },
        {
            title: "一级分类",
            field: "accounttype"
        },
        {
            title: "二级分类",
            field: "contenttype"
        },
        {
            title: "媒体侧自然返点",
            field: "devidedrate"
        },
        {
            title: "星图指数",
            field: "topscore"
        },
        {
            title: "达人推荐理由",
            field: "reason"
        },
        {
            title: "行业标签",
            field: "industry_tags"
        },
        {
            title: "最近一次更新时间",
            field: "last_video_time"
        },
      ]
      this.exportDialg.quotationColumns = [
        {
            title: "1-20报价",
            field: "twentyprice"
        },
        {
            title: "21-60报价",
            field: "sixtyprice"
        },
        {
            title: "60+报价",
            field: "sixtyoverprice"
        },
        {
            title: "明星视频报价",
            field: "price_61"
        },
        {
            title: "合集视频报价",
            field: "price_73"
        },
        {
            title: "共创视频主投稿人报价",
            field: "price_90"
        },
        {
            title: "共创视频参与报价",
            field: "price_91"
        },
        {
            title: "品牌推广专场（按小时）",
            field: "price_9"
        },
        {
            title: "品牌推广专场（按天）",
            field: "price_56"
        },
        {
            title: "电商带货专场",
            field: "price_52"
        },
        {
            title: "电商带货拼场",
            field: "price_53"
        },

      ]
      this.exportDialg.fansColumns = [
        {
            title: "粉丝量（W）",
            field: "fans"
        },
        {
            title: "男粉占比",
            field: "i_percent"
        },
        {
            title: "女粉占比",
            field: "o_percent"
        },
        {
            title: "18-23岁粉丝占比",
            field: "fans_age_pct_1"
        },
        {
            title: "24-30岁粉丝占比",
            field: "fans_age_pct_2"
        },
        {
            title: "31-40岁粉丝占比",
            field: "fans_age_pct_3"
        },
        {
            title: "41-50岁粉丝占比",
            field: "fans_age_pct_4"
        },
        {
            title: "50+岁粉丝占比",
            field: "fans_age_pct_5"
        },
      ]
      this.exportDialg.worksColumns = [
        {
            title: "预期CPM",
            field: "cpm"
        },
        {
            title: "近30天播放量",
            field: "expectedplay"
        },
        {
            title: "完播率",
            field: "playcmt"
        },
        {
            title: "互动率",
            field: "interact"
        },
        {
            title: "商单完播率",
            field: "sd_playcmt"
        },
        {
            title: "商单互动率",
            field: "sd_interact"
        },
        {
            title: "商单播放量中位数",
            field: "sd_median"
        },
        {
            title: "近5个日常视频平均播放量（W）",
            field: "avg_play5"
        },
        {
            title: "近5个商单视频平均播放量（W）",
            field: "sd_avg_play5"
        },
        {
            title: "近10个日常视频平均播放量（W）",
            field: "avg_play10"
        },
        {
            title: "近10个商单视频平均播放量（W）",
            field: "sd_avg_play10"
        },
        {
            title: "近15个日常视频平均播放量（W）",
            field: "avg_play15"
        },
        {
            title: "近15个商单视频平均播放量（W）",
            field: "sd_avg_play15"
        },
      ]
      this.exportDialg.audienceColumns = [
        {
            title: "观众性别",
            field: "wfanssex"
        },
        {
            title: "观众性别占比",
            field: "wfanssexpct"
        },
        {
            title: "观众年龄分布",
            field: "wfansagefb"
        },
        {
            title: "观众年龄分布占比",
            field: "wfansagefbpct"
        },
        {
            title: "活跃观众占比",
            field: "wfansactivepct"
        },
        {
            title: "男观众占比",
            field: "watcher_i_percent"
        },
        {
            title: "女观众占比",
            field: "watcher_o_percent"
        },
        {
            title: "观众18-23岁占比",
            field: "watcher_age_pct_1"
        },
        {
            title: "观众24-30岁占比",
            field: "watcher_age_pct_2"
        },
        {
            title: "观众31-40岁占比",
            field: "watcher_age_pct_3"
        },
        {
            title: "观众41-50岁占比",
            field: "watcher_age_pct_4"
        },
        {
            title: "观众50岁+占比",
            field: "watcher_age_pct_5"
        },

      ]

      this.exportDialg.checkListInit = ["昵称","账号ID","UID","星图ID","主页链接","一级分类","二级分类","1-20报价","21-60报价","60+报价","粉丝量（W）",]

      // 勾选'已开通直播'搜索项时显示直播导出列
      if (this.query.is_live == 1) {
        this.exportDialg.liveColumns = [
          { title: 'ACU', field: 'acu' },
          { title: 'PCU', field: 'pcu' },
          { title: '近期直播场次', field: 'room_cnt' },
          { title: '平均观看人次', field: 'watch_cnt_avg' },
          { title: '平均观看人数', field: 'watch_ucnt_avg' },
          { title: '粉丝观看占比', field: 'fans_watch_rate' },
          { title: '场均涨粉数', field: 'follow_ucnt_avg' },
          { title: '场均点赞比', field: 'like_rate_avg' },
          { title: '平均播放时长', field: 'watch_duration_avg' },
          { title: '场均CTR', field: 'ctr_avg' },
          { title: '小风车CTR', field: 'windmill_ctr_avg' },
          { title: '小手柄场均CTR', field: 'handle_ctr_avg' },
          { title: '小手柄场均CVR', field: 'handle_cvr_avg' },
          { title: '小雪花场均CTR', field: 'snowflake_ctr_avg' },
        ]
      } else {
        this.exportDialg.liveColumns = []
      }
      this.exportDialg.show = true
    },
    getMyTable(){
      // 由于历史原因，从first文件中获取的参数会有一些遗留的字段（咨询过后端，只要遗留字段与正在使用的字段不重复就不会有影响，后续如确定用不到的，可删除）
      let params = this.handleQuery()
      let {main, other = ''} = params
      // params: main为正常的对象数据：{fans_min; 100}  other为在选项的value中拼接好的字符串参数，如粉丝画像的粉丝性别：fans_grenders=男&fans_sex_pct_min=50
      let {page, limit: page_size} = this.pager

       // 如果选择签约号，则优先按 独家达人 排序
      if (params.main.product_logings == '签约号' && !this.sort) {
        this.sort = 'contract_type'
        this.sortType = 1
      }

      params = {
        ...main,
        page,
        page_size,
        sort: this.sort,
        sort_type: this.sortType
      }

      let newQuery = {}
      Object.keys(params).forEach(x => {
        if(x.startsWith('price_') && x.split('_').length < 3) {
            let keyName = x.split('_')[1]
            const keyMap = {
              1: 'price_20',
              2: 'price',
              3: 'price_999',
              4: 'price_61',
              5: 'price_73',
              6: 'price_90',
              7: 'price_91',
              8: 'price_9',
              9: 'price_56',
              10: 'price_52',
              11: 'price_53',
            }
            newQuery[`${keyMap[this.customDialog.realForm.priceType]}_${keyName}`] = params[x]
        }else {
          newQuery[x] = params[x]
        }
      })

      let fans_price_type = localStorage.getItem('fans_price_type')
      let priceTypeList_copy = []
      priceTypeList_copy = this._.cloneDeep(this.priceTypeList)
      this.priceTypeList = priceTypeList_copy.map(item => {
        if(fans_price_type){
          item.disabled = true
        }else{
          if(fans_price_type == "0"){
            item.disabled = true
          }else{
            item.disabled = false
          }
        }
        return item
        })
      this.priceTypeList.forEach(x=>{
        if(x.value == fans_price_type){
          let priceType = x.label
          this.customDialog.form.priceType = priceType
          this.customDialog.realForm.priceType = priceType
          localStorage.setItem("priceType", JSON.stringify(this.customDialog.realForm.priceType));
        }
      })
      if(!fans_price_type || fans_price_type == "0"){
        let priceType = JSON.parse(localStorage.getItem("priceType"))
          ? JSON.parse(localStorage.getItem("priceType"))
          : 2;
        this.customDialog.form.priceType = priceType
        this.customDialog.realForm.priceType = priceType

      }

      params = newQuery

      this.tableParams = this._.cloneDeep(params)
      let url = `/api.php?m=index|api|gx&a=search`
      if (other) {
        url += `&${other}`
      }
      this.loading = true
      this.$axios.get(url, {
        params,
        headers: { showLoading: false },
      }).then(res => {
        this.loading = false
        let {list = [], page_info = {}, stats = {}} = res || {}
        // console.log(list, page_info);

        let ids = []
        // 3个月前的日期节点
        const newSignDateFlag = this.dayjs().subtract(3, 'month')
        list.forEach(x => {
          ids.push(x.id)
          x.avg_quality = x.avg_quality ? Math.round(+x.avg_quality) : 0
          x.avg_experience = x.avg_experience ? Math.round(+x.avg_experience) : 0
          x.avg_effect = x.avg_effect ? Math.round(+x.avg_effect) : 0

          x.industry_tags = [...new Set(x.industry_tags?.split(',')?.map(item=>item.split('-')[0]))]?.join(',')
          x.special_saletype = x.special_saletype?.split(',')?.filter(item => item !== '促销' && item)?.[0]

          // 历史签约号
          x.isHistorySign = x.logings !== '签约号' && x.has_sign == 1
          // 新签约号，当前是签约号，并且签约时间在3个月内
          x.isNewSign = x.logings == '签约号' && newSignDateFlag.isBefore(x.last_sign_time)
          Object.keys(x).forEach(field => {
            if([
              'fans_watch_rate',
              'like_rate_avg',
              'ctr_avg',
              'windmill_ctr_avg',
              'handle_ctr_avg',
              'handle_cvr_avg',
              'snowflake_ctr_avg',
            ].includes(field)){
              x[field] = this.$utils.formatValue(x[field],'rate')
            }else if([
              'watch_duration_avg',
            ].includes(field)){
              x[field] = this.$utils.formatValue(x[field],'time:m-s')
            }
          })

        })
        this.vxeTableData = list
        if(window.scrollY > 600) {
          this.$nextTick(() => {
            window.scrollTo({
              top: 600,
              behavior: 'smooth'
            })
          })
        }
        this.getChart(ids.join())
        this.pager.total = page_info.total * 1
        this.exportFrequency = stats.export

      }).finally(() => {
        this.loading = false
      })
      // 世明那边的埋点
      // this.$api.setUserTimeLog()
    },
    getHoverFun(params, ticket, cb){
      let id = params[0].data.id || ''
      let a = params[0].seriesName == "媒体侧自然返点" ? 'getTalentMapDetail' : 'getMapDetail'
      this.$axios.get(`/api.php?m=index|api|gx&a=${a}&cid=${id}`, {
        headers: { showLoading: false },
      }).then(res => {
        this.hoveredChart[id] = {
          status: 'finished',
          ...res
        }
        cb(ticket, this.handleHoverData(params, res || {}))
      }).catch(res => {
        this.hoveredChart[id].status = ''
      })
    },
    showCalendarDia(row) {
      this.calendarInfo = {
        plat: '抖音',
        shortid: row.shortid || '',
        starid: row.starid || ''
      }
      this.outerDiaVisible = true
    },
    showPjModal(row){
      console.log('row :>> ', row);
      this.pjModalShow = true
      this.pjId = row.id
    },
    sortChange(args) {
      let { property, order } = args
      this.sort = order ? property : ''
      this.sortType = order === 'desc' || !order ? 1 : 0
      this.pager.page = 1
      this.getMyTable()
    },
    pageChange({ type, currentPage, pageSize }) {
      if (type == 'size') {
        this.pager.page = 1
      }
      this.getMyTable()
    },
    handleNum(value, column) {
      // todo1 报价加4个 √
      if (['twentyprice', 'sixtyprice', 'sixtyoverprice', 'price_61', 'price_73', 'price_90', 'price_91','price_9','price_56','price_52','price_53'].includes(column.field)) {
        if (value) {
          return `¥${this.fmt(value/10000, {micrometer: true})}w`
        } else {
          return '-'
        }
      }
      if (['fans','expectedplay'].includes(column.field)) {
        if (value) {

          return value >=10000 ? (value/10000).toFixed(2).toLocaleString()+ 'w' : value
          // return `${this.fmt(value/10000, {micrometer: true})}w`
        } else {
          return '-'
        }
      }
      if (column.title.endsWith('率')) {
        return value ? `${this.fmt(value)}%` : '0%'
      } else {
        return this.fmt(value, {micrometer: true}) || 0
      }
    },
    handleClick(row,field){
      console.log('this.plat :>> ', this.plat);
      console.log('field :>> ', field);
      console.log('row :>> ', row);
      let order_type = field?.split("_c_count")?.[0] || ''
      if(order_type == "一口价直播" || order_type == "一口价直播（框架资源包）"){
        this.detail_field = this.searchOptionsObj.detail_field.filter(x=>{
          if(["订单单号","游戏类型","产品类型","营销标的","达人报价","实际利润率"].includes(x.name)){
            return x
          }
        })
      } else if(order_type == "直播-CPA"){
        this.detail_field = this.searchOptionsObj.detail_field.filter(x=>{
          if(["订单单号","营销标的","达人报价","实际利润率"].includes(x.name)){
            return x
          }
        })
      } else if(order_type == "短视频生态"  ){
        this.detail_field = this.searchOptionsObj.detail_field.filter(x=>{
          if(["订单单号","产品名","营销标的","总支出（税后）"].includes(x.name)){
            return x
          }
        })
      } else if(order_type == "直播生态"){
        this.detail_field = this.searchOptionsObj.detail_field.filter(x=>{
          if(["订单单号","产品名","营销标的","总支出（税后）","实际支付成本税后"].includes(x.name)){
            return x
          }
        })
      } else {
          this.detail_field = this.searchOptionsObj.detail_field.filter(x=>{
            if(["订单单号","产品类型","营销标的"].includes(x.name)){
              return x
            }
          })
      }
      let params = {
        order_type,
        plat: "抖音",
        page: this.detailTablePage,
        limit: this.detailTableLimit,
        shortid: row.shortid,
      }
      this.detailTableLoading = true
      this.$axios.post('/api.php?m=case|api|gx&a=drcaselist', params, {headers: { showLoading: false}}).then(res => {
        let {rows = [], totalCount = 0} = res || {}
        this.detailTableTotal = totalCount
        this.detailTableData = rows
      }).catch( err => {})
      .finally(() => {
        this.detailTableLoading = false
      })

    },
    showCustomDialog() {
      console.log('打开自定义列',this.customDialog.realForm);

      this.customDialog.form = this._.cloneDeep(this.customDialog.realForm)
      this.customDialog.show = true
    },
    customDialogConfirm() {
      this.customDialog.realForm = this._.cloneDeep(this.customDialog.form)
      localStorage.setItem("checkList", JSON.stringify(this.customDialog.realForm.checkList));
      // localStorage.setItem("cooperateList", JSON.stringify(this.customDialog.realForm.cooperateList));
      localStorage.setItem("priceType", JSON.stringify(this.customDialog.realForm.priceType));

      this.customDialog.show = false
      this.getMyTable()
    },
    getChart(ids) {
      let order_type = this.tableParams.order_type || []
      this.$axios.get(`/api.php?m=index|api|gx&a=getTalentOrderMap&lids=${ids}&order_type=${order_type.join()}`, {headers: { showLoading: false }}).then(res => {
        let {list = {}, bad_review_list = []} = res
        for (const key in list) {
          // console.log('key :>> ', key);
          list[key]?.forEach(x => {
            // console.log('x :>> ', x);
            let idx = this.vxeTableData.findIndex(y => y.id == x.mid)
            if (idx !== -1) {
              let chartMap = {}
              let countMap = {}

              this.myColumns.forEach(y => {

                if ((y.field.endsWith('_mychart') && y.field.includes(key)) || y.title.includes('利润率')) {

                  if( y.yField == "profit_rate" && (x[y.yField]?.length == 0 || !x[y.yField])){
                    chartMap[y.field] = x[y.yField]
                  }else{
                    let baseChart = this._.cloneDeep(this.barData)
                    baseChart.xAxis = (x[y.xField] || []).map(x => this.dayjs(x).format('MM-DD'))
                    baseChart.data[0].data = (x[y.yField] || [])
                    baseChart.data[0].name = y.title
                    // 判断是否有data数据 没有data数据的话 就不渲染图表
                    baseChart.hasData = baseChart.data[0].data?.length > 0
                    baseChart.firstData = baseChart.data[0].data?.[0]?.value || ""
                    chartMap[y.field] = baseChart
                  }
                } else if (y.field.endsWith('_c_count') && y.field?.split('_')?.[0] == key) {  // 各产品合作次数
                    countMap[y.field] = x?.total_count ? x?.total_count : 0
                }
              })
              this.vxeTableData.splice(idx, 1, {
                ...this.vxeTableData[idx],
                ...countMap,
                ...chartMap
              })
            }
          })
        }
        bad_review_list.forEach(x => {
          let idx = this.vxeTableData.findIndex(y => y.id == x.mid)
          if (idx !== -1) {
            this.$set(this.vxeTableData[idx],'warnTips','近180天有合作不满意记录')
          }
        })
      })

    },
    getDevidedrateChart(id){
      this.$axios.get(`/api.php?m=index|api|gx&a=getTalentMap&lid=${id}`, {headers: { showLoading: false }}).then(res => {
        let {devidedrate= [],devidedrate_time=[]} = res
        console.log('res :>> ', res);
        let chartMap = {}
        let baseChart = this._.cloneDeep(this.barData)
            baseChart.xAxis = (devidedrate_time|| []).map(x => this.dayjs(x).format('MM-DD'))
            baseChart.data[0].data = (devidedrate || [])
            baseChart.data[0].name = "媒体侧自然返点"
            // 判断是否有data数据 没有data数据的话 就不渲染图表
            baseChart.hasData = baseChart.data[0].data?.length > 0
            baseChart.firstData = baseChart.data[0].data?.[0]?.value || ""
            chartMap.devidedrateChart = baseChart
            // let id = 0
            let idx = this.vxeTableData.findIndex(y => y.id == id)
            this.vxeTableData.splice(idx, 1, {
                ...this.vxeTableData[idx],
                ...chartMap
              })
      })
    },
    handleHoverData(params, data = {}) {
      console.log('params, data :>> ', params, data);
      let title = ""
      let content = ""
      if(params[0].seriesName == "媒体侧自然返点"){
        title = `<span style="font-size: 14px; font-weight: bold; color: #333; margin-bottom: 20px">${params[0].name}</span>`
        content = `
          <div style="width: 240px; display: flex;justify-content: space-between; align-items: center; font-size: 12px; color: #333;">
            <span>更新时间：</span>
            <span style="font-weight: bold;">${data.optdt|| ''}</span>
          </div>
          <div style="width: 240px; display: flex;justify-content: space-between; align-items: center; font-size: 12px; color: #333;">
            <span>更新前比例：</span>
            <span style="font-weight: bold;">${data.oldval || ''}</span>
          </div>
          <div style="width: 240px; display: flex;justify-content: space-between; align-items: center; font-size: 12px; color: #333;">
            <span>更新后比例：</span>
            <span style="font-weight: bold;">${data.newval || ''}</span>
          </div>
          <div style="width: 240px; display: flex;justify-content: space-between; align-items: center; font-size: 12px; color: #333;">
            <span>数据源：</span>
            <span style="font-weight: bold;">${data.optname || ''}</span>
          </div>
        `
      }else{

        title = `<span style="font-size: 14px; font-weight: bold; color: #333; margin-bottom: 20px">${params[0].name}</span>`
        content = `
          <div style="width: 240px; display: flex;justify-content: space-between; align-items: center; font-size: 12px; color: #333;">
            <span>订单号：</span>
            <span style="font-weight: bold;">${data.order_num || ''}</span>
          </div>
          <div style="width: 240px; display: flex;justify-content: space-between; align-items: center; font-size: 12px; color: #333;">
            <span>${params[0].seriesName}：</span>
            <span style="font-weight: bold;">${params[0].value || ''}</span>
          </div>
        `
        if (data.supplier_name && data.supplier_name !== '无') {
          content += `
            <div style="width: 240px; display: flex;justify-content: space-between; align-items: center; font-size: 12px; color: #333;">
              <span>供应商：</span>
              <span style="font-weight: bold;">${data.supplier_name}</span>
            </div>
          `
        }
        content += `
          <div style="width: 240px; display: flex;justify-content: space-between; align-items: center; font-size: 12px; color: #333;">
            <span>客户：</span>
            <span style="font-weight: bold;">${data.cust_name || ''}</span>
          </div>
          <div style="width: 240px; display: flex;justify-content: space-between; align-items: center; font-size: 12px; color: #333;">
            <span>营销标的：</span>
            <span style="font-weight: bold;">${data.product || ''}</span>
          </div>`
        }
        return title + content
    },
    handleQuery() {
      // 特殊处理粉丝画像和观众画像的请求参数
      // 这个方法会特殊处理韬哥给的options的value为 “xxxxxx=20%”的
      let keyList = ['fans_age', 'fans_grenders', 'fans_systems', 'fans_cities', 'watcher_age', 'watcher_grenders', 'watcher_systems', 'watcher_cities', 'devidedrate_ge', 'xglt_count']
      let other = [], copyQuery = this._.cloneDeep(this.query)
      keyList.forEach(x => {
        if (copyQuery[x]) {
          if(copyQuery[x] instanceof Array) {
            copyQuery[x]?.forEach(_x => {
              other.push(_x)
            })
          }else {
            other.push(copyQuery[x])
          }
          delete copyQuery[x]
        }
      })

      // copyQuery.last_video_time_type = copyQuery.last_video_time_type ? 'month' : ''
      // copyQuery.control_status = copyQuery.control_status ? '是' : ''

      return {
        main: copyQuery,
        other: other.join('&')
      }
    },
    tableBtnClick(args) {
      let { row, column } = args
      if (column.field == 'video_count') {
        this.relatedVideoTalentInfo = {...row}
        this.$refs.relatedVideo.show()
        return
      }

      LA.track("dy_short_video_talentinfo");
      let routeData = this.$router.resolve({
        path: "/daren",
        query: {
          id: row.starid,
          logings: row.logings,
          shortid: row.shortid,
          mid:row.id,
        },
      });
      let page = window.open(routeData.href, "_blank");
      this.subPageList.push(page)

      // 详情页浏览频率埋点
      let logParams = {
        type: 4,
        plat: 1,
        shortid: row.shortid || "",
        starid: row.starid || ""
      }
      this.$api.setUseLog(logParams)
    },
    batchLockHandle() {
      const checkedData = this.$refs.mainTableRef?.getCheckboxRecords()
      this.$refs.ScheduleBatchAddModal.show(checkedData)

    },
    exportHandle(checkList) {
      let checkedData = this.$refs.mainTableRef?.getCheckboxRecords()
      if(!checkedData.length && localStorage.getItem('uid') != 1) {
        this.$message.warning(`请勾选要导出的达人！`)
        return
      }

      // if(localStorage.getItem('uid') != 1 && checkedData.length > 30) {
      //   this.$message.warning(`每次最多可导30个达人！`)
      //   return
      // }

      let params = {
        page: 1,
        page_size: localStorage.getItem('uid') == 1 ? 10000 : this.pager.limit + 10,
        search_type: 'export',
        shortids: checkedData.map(x => x.shortid).filter(x => x).join(),
        plat: 1,
        is_black: 1,
        is_sup_black: 1,
      }

      this.loading = true
      let url = `/api.php?m=index|api|gx&a=search`
      if(!checkedData.length && localStorage.getItem('uid') == 1) {
        let specialParams = this.handleQuery()
        let {main, other = ''} = specialParams
        if (other) {
          url += `&${other}`
        }
        params = {
          ...this.tableParams,
          page: 1,
          page_size: 10000,
          search_type: 'export',
          plat: 1
        }
      }

      this.$axios.get(url, { params, headers: { showLoading: false }, }).then(res => {
        this.loading = false
        let {list = [], stats = {}} = res || {}
        this.exportFrequency = stats.export
        if(stats?.black_count == 0){//没有黑名单达人
          if(!list.length) {
            this.$message.warning(`没有需要导出的数据！`)
        }else {
          list.forEach((item, index)=>{
            if (item.month_examples_data) {
              [
                'account_id',
                'is_hot',
                'is_must',
                'discount',
                'reason',
                'is_real_person',
                'is_same_price',
                'notes',
                'rank_score',
              ].forEach(key =>{
                item[key] = item.month_examples_data[key]
              })
            }
          })
          let allcolumns = [...this.exportDialg.baseColumns,...this.exportDialg.quotationColumns,...this.exportDialg.fansColumns,...this.exportDialg.worksColumns,...this.exportDialg.audienceColumns,...this.exportDialg.liveColumns]
          let titles = []
          let fileds = []
          fileds = allcolumns.filter(x => checkList.includes(x.title)).map(x => x.field)
          titles = allcolumns.filter(x => checkList.includes(x.title)).map(x => x.title)
          // let fileds = ['starid', 'accounttype', 'contenttype', 'nickname', 'uniqueid', 'shortid', 'homepage', 'fans', 'i_percent', 'fans_age_pct_1', 'fans_age_pct_2', 'fans_age_pct_3', 'avg_play5', 'sd_avg_play5', 'twentyprice', 'sixtyprice', 'sixtyoverprice', 'cpm', 'expectedplay']
          // let titles = ['星图ID', '一级分类', '二级分类', '昵称', '账号ID', 'UID', '主页链接', '粉丝量（W）', '男粉占比', '18-23岁年龄层粉丝占比', '24-30岁年龄层粉丝占比', '31-40岁年龄层粉丝占比', '近5个日常视频平均播放量（W）', '近5个商单视频平均播放量（W）', '1-20报价', '21-60报价', '60+报价', '预期CPM', '近30天播放量']
          let data = list.map(x => {
            let cur = []
            fileds.forEach(field => {
              let result = {}
              if(['avg_play5', 'sd_avg_play5', 'expectedplay'].includes(field)){
                result = this.fmt(x[field], { micrometer: true })
              }else if (['fans'].includes(field)){
                result = this.fmt(x[field]/10000, { micrometer: true })
              }else if([
                'fans_watch_rate',
                'like_rate_avg',
                'ctr_avg',
                'windmill_ctr_avg',
                'handle_ctr_avg',
                'handle_cvr_avg',
                'snowflake_ctr_avg',
              ].includes(field)){
                result = this.$utils.formatValue(x[field],'rate')
              }else if([
                'watch_duration_avg',
              ].includes(field)){
                result = this.$utils.formatValue(x[field],'time:m-s')
              }else{
                result = x[field]
              }
              cur.push(result)
            })
            return cur
          })
          const ws = XLSX.utils.aoa_to_sheet([titles, ...data]);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
          XLSX.writeFile(wb, `达人.xlsx`);
          this.$message.success(`已为您导出${list.length}条达人数据`)

        }
        }else{
          let confirmText = ``
        if(stats?.rec_count == 0){//没强推达人
          confirmText = `你所勾选导出的达人中包含${checkedData.map(x => (x.is_black == 1 || x.is_sup_black == 1) ? x.nickname : '').filter(x => x).join()}黑名单达人，将为你排除${stats?.black_count || 0}位达人，实际将导出${list?.length}位达人。`
        }else{//有强推达人
          let black_num = checkedData.filter(x => (x.is_black == "1" || x.is_sup_black == "1"))?.length
          let rec_num = checkedData.filter(x => (x.is_rec == "1"))?.length
          if(black_num == rec_num){//黑名单达人全部为强推达人
            confirmText = `你所勾选导出的达人中包含${checkedData.map(x => (x.is_black == 1 || x.is_sup_black == 1) ? x.nickname : '').filter(x => x).join()}黑名单达人，但由于这些达人都是强推达人，系统将强制导出，实际将导出${list?.length}位达人。`
          }else{
            confirmText = `你所勾选导出的达人中包含${checkedData.map(x => (x.is_black == 1 || x.is_sup_black == 1) ? x.nickname : '').filter(x => x).join()}黑名单达人，但由于系统内有${stats?.rec_count || 0}位强推达人，实际将导出${list?.length}位达人。`
          }
        }
        if(!list.length) {
          this.$confirm(confirmText, '导出数据排除黑名单达人提示', {
            confirmButtonText: '了解，回到列表',
            type: 'warning'
          }).then(() => {

          }).catch(() => {})
        }else {
          this.$confirm(confirmText, '导出数据排除黑名单达人提示', {
            confirmButtonText: '了解，确认导出',
            type: 'warning'
          }).then(() => {
          // 数据中的对象下的字段补充到row本身，来导出，注意字段名是否重复
            list.forEach((item, index)=>{
              if (item.month_examples_data) {
                [
                  'account_id',
                  'is_hot',
                  'is_must',
                  'discount',
                  'reason',
                  'is_real_person',
                  'is_same_price',
                  'notes',
                  'rank_score',
                ].forEach(key =>{
                  item[key] = item.month_examples_data[key]
                })
              }
            })
            let allcolumns = [...this.exportDialg.baseColumns,...this.exportDialg.quotationColumns,...this.exportDialg.fansColumns,...this.exportDialg.worksColumns,...this.exportDialg.audienceColumns,...this.exportDialg.liveColumns]
            let titles = []
            let fileds = []
            fileds = allcolumns.filter(x => checkList.includes(x.title)).map(x => x.field)
            titles = allcolumns.filter(x => checkList.includes(x.title)).map(x => x.title)

            // let fileds = ['starid', 'accounttype', 'contenttype', 'nickname', 'uniqueid', 'shortid', 'homepage', 'fans', 'i_percent', 'fans_age_pct_1', 'fans_age_pct_2', 'fans_age_pct_3', 'avg_play5', 'sd_avg_play5', 'twentyprice', 'sixtyprice', 'sixtyoverprice', 'cpm', 'expectedplay']
            // let titles = ['星图ID', '一级分类', '二级分类', '昵称', '账号ID', 'UID', '主页链接', '粉丝量（W）', '男粉占比', '18-23岁年龄层粉丝占比', '24-30岁年龄层粉丝占比', '31-40岁年龄层粉丝占比', '近5个日常视频平均播放量（W）', '近5个商单视频平均播放量（W）', '1-20报价', '21-60报价', '60+报价', '预期CPM', '近30天播放量']
            let data = list.map(x => {
              let cur = []
              fileds.forEach(field => {
                let result = {}
                if(['avg_play5', 'sd_avg_play5', 'expectedplay'].includes(field)){
                result = this.fmt(x[field], { micrometer: true })
                }else if (['fans'].includes(field)){
                    result = this.fmt(x[field]/10000, { micrometer: true })
                }else{
                    result = x[field]
                }
                cur.push(result)
              })
              return cur
            })

            const ws = XLSX.utils.aoa_to_sheet([titles, ...data]);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
            XLSX.writeFile(wb, `达人.xlsx`);
            this.$message.success(`已为您导出${list.length}条达人数据`)
          }).catch(() => {})

        }
        }

      }).finally(() => {
        this.loading = false
      })
        // 导出埋点
        let queryParams = this.handleQuery()
        let {main, other = ''} = queryParams

        let logParams = {
        type: 42,
        plat: 1,
        shortids: params.shortids || "",
        tags: JSON.parse(localStorage.getItem("tagsParams")) || []
      }
      this.$api.setUseLog(logParams)
    },
    onDrJoin({row}){
      // 将达人添加到询单埋点
      this.$api.setUseLog({
        type: 31,
        plat: 1,
        shortid: row.shortid || "",
        starid: row.starid || ""
      })
      this.currentDrInfo = row
      if(row?.is_ban == 1 || row?.is_black == 1 || row?.is_sup_black == 1 ){
        this.$modal.message({status: 'warning', content: '该达人已被拉黑，无法加入询单~'})
        return
      }
      this.drJoinShow = true
    },
    showCalculator({row}) {
      this.calcDialogData = {
        show: true,
        talentInfo: {
          nickName: row.nickname
        }
      }
    },
    async showStarChangeHistory(event,row){
      if (!row?._starChangeHistory) {
        const data = await this.$axios.get('api.php?m=index|api|gx&a=talentSupLog', {
          params:{
            mid: row.id
          },
          headers: { showLoading: false },
        })
        this.$set(row,'_starChangeHistory', data )
      }
      this.starChangeHistory = row._starChangeHistory
      if (!this.starChangeHistory.length) {
        return
      }
      setTimeout(()=>{
        const contentRect = this.$refs.custom_popver.getBoundingClientRect()
        const rect = event.target.getBoundingClientRect()
        let top = rect.bottom - contentRect.height/2,left = rect.right + 4
        if(top + contentRect.height > innerHeight ) {
          top = innerHeight - contentRect.height - 10
        }
        this.$refs.custom_popver.style.top= top + 'px'
        this.$refs.custom_popver.style.left= left + 'px'
        this.$refs.custom_popver.classList.add('show')
        addEventListener("scroll", this.hideStarChangeHistory, { once: true })
      },0)

    },
    hideStarChangeHistory(){
      this.$refs.custom_popver.classList.remove('show')
      removeEventListener("scroll", this.hideStarChangeHistory)
    },
    handleAddCommand(scope,command){
      switch (command) {
        case 'add-to-xd':
          this.onDrJoin(scope)
          break;
        case 'add-to-cart':
          this.onDrCartJoin(scope)
          break;
      }
    },
    // 抖音主页
    onToDrHome(scope){
      const url = `https://www.douyin.com/user/${scope.row.secuid}`
      window.open(url)
    },
    onRepresentVideoShow({row}){
      this.representVideoTalentInfo = {...row}
      // this.$refs.representVideo.show(row.starid)
      this.$refs.representVideo.show()
    },
    async onDrCartJoin({row}){
      const data = await this.$axios.get('api.php?m=cart|api|gx&a=add', {
        params:{
          lid: row.id,
          plat: '抖音'
        },
        headers: { showLoading: false },
      })
      this.$message.success('添加成功')
      this.$store.dispatch('shoppingCart/refreshCount')
    },
    async onDrCartBatchJoin(){
      const rows = this.$refs.mainTableRef?.getCheckboxRecords()
      if (!rows.length) {
        this.$modal.message({status: 'warning', content: '请先选择达人'})
        return
      }
      const data = await this.$axios.get('api.php?m=cart|api|gx&a=batchAdd', {
        params:{
          lids: rows.map(row => row.id).join(','),
          plat: '抖音'
        },
        headers: { showLoading: false },
      })
      this.$message.success('添加成功')
      this.$store.dispatch('shoppingCart/refreshCount')
    },

    async onXgltCountPopShow(row){
      if(row._xgltCountData){
        return row._xgltCountData
      }
      // 后端返数组
      let data = await this.$axios.get('api.php?m=index|api|gx&a=getXgltStats', {
        params:{
          shortid: row.shortid
        },
        headers: { showLoading: false },
      })
      if(Array.isArray(data)){
       data = data?.[0]
      }
      if(!data){
        return
      }
      console.log('xgltdata',data);
      this.$set(
        row,
        '_xgltCountData',
        [
          { title: '参与星广任务数', value: this.fmt(data.count,{isEng:true})},
          { title: '已发布视频数', value: this.fmt(data.item_count,{isEng:true})},
          { title: '累计广告消耗', value: this.fmt(data.est_real_time_ad_cost,{isEng:true})},
          { title: '累计预估收益', value: this.fmt(data.est_provider_reward_amount,{isEng:true})},
        ]
      )
      console.log('data :>> ', data);
    },
    onToPage(row){
      this.$utils.openOtherSystem({
        sys:'集团数据看板',
        path: `/dept-mcn/xg-joint-investment-talent?atype=all&pnum=all&key=${row.shortid}`
      })
    },
    toCrmLibrary({row}, type) {
      let origin = location.origin.includes('test') ? 'http://test.erp.changwankeji.com:8080' : 'https://erp.changwankeji.com:8188'
      let url = `${origin}/dist/index.html#/crmlibrary/${type}?id=${row.id}`
      window.open(url)
    },
    async handleDrop(flag, row){
      if(!flag){
        this.dropRole = {
          isread: false,
          isedit: false
        }
        return
      }
      this.dropdownLoading = true
      this.$axios.get(`/api.php?m=detail|api|gx&a=getAuth&lid=${row.id}`,{headers: { showLoading: false }}).then(async res => {
        this.dropRole = res || {}
      }).finally(() => {
        this.dropdownLoading = false
      })
    },
  },
};
</script>
<style lang="less">
.kol_table{
  .vxe-cell--title{
    font-weight: normal !important;
   }
  .vxe-body--column{
   padding:8px 0 !important;
  }

}
.xglt-count-popover{
    font-family: "苹方", sans-serif;
    font-weight: 400;
    font-style: normal;
    text-align: center;

  .form{
    display: flex;
    flex-flow: row wrap;
    height: 140px;
    .form-item{
      flex: 1 1 50%;
      margin-bottom: 10px;
      .title{
        font-size: 14px;
        color: #6b7785;
        margin-bottom: 10px;
      }
      .value{
        font-weight: 500;
        font-size: 18px;
        color: #ff6f28;
      }
    }
  }
  .to-panel{
      font-size: 14px;
      color: #ff6f28;
      cursor: pointer;
      img{
        width: 20px;
        margin-right: 4px;
        vertical-align: middle;
      }
  }
}
</style>

<style scoped lang="less">
@import url('../../../assets/css/table-style.less');
  .topBox{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    background: #f7f8fa;
    margin-top: 20px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    box-shadow: rgba(0, 0, 0, 0.098) 0px 2px 6px;
    .leftBox{
    }
  }
  .pj_icon{
    width: 20px;
    height: 20px;
    margin-left: 5px;
    cursor: pointer
  }
  // .rowBtn{
  //   background-color:#FF6F28;
  //   width: 30px !important;
  //   height: 30px !important;
  //   cursor: pointer;
  //   // padding: 5px;
  //   img{
  //     width: 30px;
  //     height: 30px;
  //   }
  //   border-radius: 50% !important;
  // }

  // 自定义弹窗
  .custom-popver{
    position: fixed;
    visibility: hidden;
    background-color: #fff;
    color: #333;
    text-align: left;
    border: 1px solid #dcdcdc;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 10px;
    z-index: 1000;
    width: 470px;
    box-sizing: border-box;
  }
  .custom-popver.show{
    visibility:visible;
  }

  .img-wrap{
    position: relative;
    .sex{
      position: absolute;
      right: 10px;
      bottom: 0px;
    }
  }
  .tag{
    display: inline-block;
    border-radius: 2px;
    background: #F6F6F6;
    color: #333333;
    padding: 2px 4px;
    margin-bottom: 4px;
  }
  .tag+.tag{
    margin-left: 4px;
  }

  .gray-nickname{
    color: #A9AEB8;
  }

</style>



